export default __webpack_public_path__ + "static/media/unlink.2a36093a.svg";